// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___2M48R","container_1":"container_1___1w3CO","container_2":"container_2___nkBwX","wp-block-cgb-block-cec-blocks":"wp-block-cgb-block-cec-blocks___1h36P"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/recipes/styles.module.scss
// module id = 479
// module chunks = 0